import React from 'react'

const AwardInfo = () => {
  const OSP_BASEURL = process.env.REACT_APP_REDIRECT_URI
  return (
    <div>
      <h1> Bookmarked awards </h1>

      <p>
        {' '}
        You can search for and bookmark your awards and award summaries from{' '}
        <a href={OSP_BASEURL.split('my-account')[0] + 'find-my-award'}>
          Find my award
        </a>
        .
      </p>

      <h3>How to bookmark awards</h3>
      <p>
        Go to{' '}
        <a href={OSP_BASEURL.split('my-account')[0] + 'find-my-award'}>
          Find my award
        </a>{' '}
        and answer a few questions about the job and industry to find the
        relevant award. Once you&apos;ve found your award click on the plus
        symbol next to the award to add that to your account.
      </p>
      <p> </p>
      <p>You can bookmark more than one award.</p>
      <p></p>
      <h2>Bookmarked awards</h2>
      <p></p>
    </div>
  )
}

export default AwardInfo
